<!--
 * @Description: 跑马灯2
 * @Author: yl
 * @Date: 2021-05-28 17:44:27
 * @LastEditTime: 2021-05-31 16:20:21
 * @LastEditors: yl
-->
<template>
    <div class="broadcast-area" style="width: 16px;height: 16px;">
        <div class="broadcast">
            <van-swipe vertical :autoplay="start ? 150 : 0" :duration="0" class="notice-swipe" :show-indicators="false"
                :touchable="false">
                <van-swipe-item v-for="(item, i) in color" :key="i">
                    <van-image class="img" :src="isLottery ? item : color[0]">
                        <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                    </van-image>
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    name: "",
    props: {
        vertical: null,
        isLottery: null,
        number: null
    },
    watch: {
        isLottery: {
            handler(v) {
                if (v) {
                    setTimeout(() => {
                        this.start = v;
                    }, this.number > 0 ? this.number * 100 : 0);
                }
            },
            immediate: false,
            deep: true
        }
    },
    data() {
        return {
            start: false,
            color: [
                require("@/assets/imges/lottery/unlight2.png"),
                require("@/assets/imges/lottery/light2.png")
            ]
        };
    }
};
</script>

<style scoped lang="scss">
.broadcast-area {
    overflow: hidden;
    // 轮播
    .broadcast {
        height: 100%;
        .notice-swipe {
            height: 100%;
        }
        .img {
            height: 16px;
            width: 16px;
        }
    }
}
</style>